import ReactDOM from 'react-dom';
import React, { useState } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import AvatarAction from './AvatarAction';
import CursorLabel from './CursorLabel';
import ButtonMore from './ButtonMore';
// import ButtonKick from './ButtonKick';
import ButtonInvite from './ButtonInvite';
import ChevronActive from '../svg/ChevronActive';
import ChevronInactive from '../svg/ChevronInactive';

const COLORS = ['#00A6ED', '#EC7D10', '#EF476F', '#9654FA', '#00A6ED',/* '#5CA7FB', '#D2BF43', '#5C5CFB' */];

function ConnectedListUsers({ admin, users = [], roomType }) {
  const limit = 4;
  const filterUsersTrackers = users.filter( x => ( x.active && x.connect && !x.spectator /*x.tracker*/ ));
  const filterUsers = users.filter( x => x.active );
  filterUsers.sort((a, b) => { // Host First Position
    const aI = a.admin ? 1 : 0;
    const bI = b.admin ? 1 : 0;
    if (aI < bI) { return 1 }
    if (aI > bI) { return -1 }
    return 0;
  });
  const total = filterUsers.length;
  const getColor = (id) => {
    const index = filterUsers.findIndex( x => x.id === id );
    return (index >= 0) ? COLORS[index] : `#00BFFF`;
  }
  const [show, setShow] = useState(true);
  const toggleSection = () => setShow(!show);
  const showCohost = (filterUsers.some(x => x.admin && !x.connect) && filterUsers.some(x => !x.admin && x.cohost && x.connect) );

  return total > 0 ? (
    <div className={`flexColumn`} style={{ gap: 10, margin: '0px 6px' }}>
      { ReactDOM.createPortal((<span id={`viewer-player-lock`} className={`viewer-player-lock none`}>Decks controls locked in viewer mode.</span>), document.getElementById(`player`)) }
      { filterUsersTrackers.map( (u,i) =>
        ReactDOM.createPortal((<CursorLabel id={`CL|${u.id}`} color={getColor(u.id)} label={u.name} />), document.getElementById(`player`))
      )}
      <div className={'flexRow'} style={{paddingBottom: 10, gap: 9, alignItems: 'center'}}>
        <div onClick={toggleSection}>
          {show ? <ChevronInactive size={14} /> : <ChevronActive size={14} /> }
        </div>
        <span className={`type-medium fz15 type-light`}>Active DJs</span>
      </div>
      { show && filterUsers.map( (u, i) => (
        <div key={`pm-u-${i}`} className={`flexCenter space-between active-in-list`}>
          <div className={`flexCenter`} style={{ justifyContent: `flex-start`, gap: 14 }}>
            <AvatarAction userID={u.id} name={u.name} source={u.avatar} color={COLORS[i]} lock={u.spectator} admin={admin} enable={!u.admin} />
            <div className={'flexColumn'}>
              { u.admin && <span className={'type-medium fz11 type-secondary'}>Host ({roomType})</span> }
              { !u.admin && showCohost && <span className={'type-medium fz11 type-secondary'}>Co-Host</span> }
              <span className={`type-medium fz14 type-light ellipsis`} style={{color: COLORS[i]}}>{u.name}</span>
            </div>
          </div>
          <div className={`flexRow`} style={{gap: 8}}>
            { /* admin && !u.admin && <ButtonKick userID={u.id} username={u.name} /> */ }
            <ButtonMore userID={u.id} />
          </div>
        </div>
      ))}
      { (show && admin && filterUsers.length < limit) && <ButtonInvite /> }
    </div>
  ) : null
}

ConnectedListUsers.propTypes = {
  admin: PropTypes.bool,
  users: PropTypes.array,
  roomType: PropTypes.string
}

const ListUsers = connect(
  state => ({
    users: state.playersInRoomPM,
    admin: !!(state.inRoomPM && state.user && state.inRoomPM.owner === state.user.id),
  })
)(ConnectedListUsers);

export default ListUsers;
